import { useTranslation } from 'react-i18next';

export const ErrorPage = () => {
  const { t } = useTranslation();

  return (
    <main className='flex min-h-screen items-center justify-center bg-[#E8EDF2] p-4 dark:bg-gray-900'>
      <div className='flex w-full max-w-[540px] flex-col items-center text-center'>
        <img src='/logo-full.svg' alt='Agentlinc' className='mb-4 h-14' />
        <h1 className='mb-4 text-6xl font-bold text-gray-900 dark:text-gray-100'>
          {t('common.errorPage.title')}
        </h1>
        <p className='mb-8 text-xl text-gray-500 dark:text-gray-400'>
          {t('common.errorPage.message')}
        </p>
        <a
          href='/'
          className="bg-primary-500 flex items-center gap-2 rounded-full px-6 py-2.5 font-['Open_Sans'] text-base leading-[1.25rem] font-normal text-[#fcfeff] transition-colors hover:bg-[#0073b3]"
        >
          {t('common.errorPage.goHome')}
        </a>
      </div>
    </main>
  );
};
